import * as ReportService from 'ReportsModule/services';
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Types from 'ReportsModule/types';
import { pickBy, identity } from 'lodash';
import { AppStateType } from 'reducers';
import ApiClientManager from 'core/apiClient';

/* -------------------------------------------------------------------------- */
export const integrationForceUpdate = createAsyncThunk(
  'integrationForceUpdate',
  async (
    {
      mosaicTeamId,
      targetServiceId,
      dataType,
      targetSide,
      ignoreWaitingResponse,
      tenantName,
      realmId,
      onSuccess,
      onFailure,
    }: Types.IntegrationForceUpdateApiParams,
    { dispatch, getState, rejectWithValue },
  ) => {
    try {
      const {
        authReducer: { user },
      } = getState() as AppStateType;

      const auth_token = user?.auth_token;
      const body = { dataType, targetSide, ignoreWaitingResponse };
      const config =
        tenantName || realmId
          ? { headers: ApiClientManager.buildUrlHeaders({ tenantName, realmId }) }
          : {};
      const response = await ReportService.integrationServerForceUpdate(
        { mosaicTeamId, targetServiceId },
        body,
        config,
        auth_token,
      );
      if (onSuccess) {
        onSuccess({ response });
      }
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      if (onFailure) {
        onFailure({ error: e });
      }
      return rejectWithValue(e);
    }
  },
);

/* -------------------------------------------------------------------------- */
export const fetchDataToIntegrationServer = createAsyncThunk(
  'fetchDataToIntegrationServer',
  async (
    {
      dataType,
      targetServiceId,
      dateAfter,
      startDate,
      projectId,
      tenantName,
      realmId,
      onSuccess,
      onFailure,
    }: Types.FetchDataToIntegrationServerApiParams,
    { dispatch, getState, rejectWithValue },
  ) => {
    try {
      const {
        authReducer: { user },
      } = getState() as AppStateType;
      const auth_token = user?.auth_token;
      const queryParams = {
        dataType,
        targetServiceId,
      };
      const body = pickBy({ dateAfter, startDate, projectId }, identity);
      const customHeaders =
        tenantName || realmId
          ? ApiClientManager.buildUrlHeaders({ tenantName, realmId })
          : undefined;
      const config = {
        params: body,
        ...(customHeaders && { headers: customHeaders }),
      };
      const response = await ReportService.fetchDataToIntegrationServer(
        queryParams,
        config,
        auth_token,
      );
      if (onSuccess) {
        onSuccess({ response });
      }
      return {
        status: response.status,
        data: response.data,
      };
    } catch (e) {
      if (onFailure) {
        onFailure({ error: e });
      }
      return rejectWithValue(e);
    }
  },
);
